module.exports = __webpack_public_path__ + "static/img/meeting.87a97069.svg";